import React, { FunctionComponent } from 'react'

import Grid from '@mui/material/Grid'
import MuiDialog from '@mui/material/Dialog'
import { styled } from '@mui/material/styles'

import { RequestFreeTrialButton } from 'components/ReusableButtons'
import Icon from 'components/shared/Icon'
import { UrlIdpRedirect } from 'helpers/redirects'
import CloseModalButtonContainer from 'redux/containers/components/CloseModalButtonContainer'

const marketingTextItems: string[] = [
  'High quality corporate precedents (corporate knowledge only)',
  'Updates on legal developments & horizon-scanning publications',
  'Public company information & analytics service (corporate knowledge only)',
  'Up-to-date legislation service'
]

const MarketingList: FunctionComponent = () => (
  <div className='marketing-list article-page-icons bg-cadet-blue white tl pt8 pb6 ph11 ph8-t ph4-m'>
    <MarketingItem text={<span>{'Searchable comprehensive Q&A with '}<i>editors' views</i>{' on difficult or unresolved points of law'}</span>} />
    {marketingTextItems.map((item, index) => <MarketingItem key={index} text={item} />)}
  </div>
)

const MarketingItem: FunctionComponent<{ text: React.ReactNode }> = ({ text }) => (
  <div className='marketing-item lh-copy f5 b pb7'>
    <Grid container direction='row' justifyContent='flex-start'>
      <Grid item xs={1}>
        <Icon name='icon-checkbox-marked-circle' />
      </Grid>
      <Grid item xs={11} className='marketing-item-text pl6'>
        {text}
      </Grid>
    </Grid>
  </div>
)

const SignUpSection: FunctionComponent = () => (
  <div className='ph8 ph7-t ph6-m'>
    <span className='dib f2 b black lh-headline mt8 mb6 disable-select'>
      Sign up to get full access
    </span>
    <RequestFreeTrialButton
      analyticsLabel='Paywall (Section)'
      showSignUpModalOnFreeTrialModalClose
    />
    <div className='dib f4 black lh-copy-variant mv6'>
      FromCounsel: Expert legal knowledge and analysis
    </div>
  </div>
)

const Dialog = styled(MuiDialog)({ '& .MuiDialog-paper': { margin: '0.5rem' } })

const SignUpModal: FunctionComponent<SignUpModalProps> = ({ isOpen, setSignUpModalIsOpen, onClose }) => {
  const handleClose = (): void => {
    setSignUpModalIsOpen(false)
    onClose?.()
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(_, reason) => reason === 'escapeKeyDown' ? undefined : handleClose()}
      disableEscapeKeyDown
      classes={{ paper: 'br0' }}
    >
      <div className='relative'>
        <CloseModalButtonContainer />
        <div className='sign-up-overlay bg-white w-100 shadow-8-04 tc z5'>
          <SignInSection />
          <SignUpSection />
          <MarketingList />
        </div>
      </div>
    </Dialog>
  )
}

const SignInSection: FunctionComponent = () => (
  <div className='sign-up-footer-wrapper bg-cadet-blue w-100 white dib'>
    <div className='sign-up-footer-content flex items-center justify-center mv7'>
      <div className='sign-up-footer-title pr3 f5 white'>
        Already have an account?
      </div>
      <a
        className='sign-in-link f5 white b no-underline hover-underline'
        href={UrlIdpRedirect()}
      >
        Sign in
      </a>
    </div>
  </div>
)

interface SignUpModalProps {
  isOpen: boolean
  setSignUpModalIsOpen: (value: boolean) => void
  onClose?: () => void
}

export default SignUpModal
